import React, { createContext } from 'react';

export type DataSheetSharedProps = {
  parent?: React.RefObject<HTMLDivElement>;

  top?: number;

  left?: number;
};

export type DataSheetPagerProps = {
  page: number;

  onChange?: (page: number) => void;

  setPage: (page: number) => void;

  parPage: number;

  total: number;
};

export const DataSheetContext = createContext<DataSheetSharedProps>({});
export const DataSheetPagerContext = createContext<DataSheetPagerProps>({ page: 1, setPage: () => {}, parPage: 50, total: 0 });

export const useSharedDataSheet = () => React.useContext(DataSheetContext);
export const useDataSheetPager = () => React.useContext(DataSheetPagerContext);
